var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "283px",
    height: "64px",
    viewBox: "0 0 283 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u66F2\u7EBF2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "2.6887907%",
    x2: "50%",
    y2: "91.698639%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C51FF",
    stopOpacity: 0.6,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C51FF",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-666.000000, -841.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u636E\\u533A",
    transform: "translate(360.000000, 745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7A33\\u5B9A\\u5E01\\u6C60",
    transform: "translate(305.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44.734142 L34.7359662,48.1554298 L73.5294663,32.4293752 L103.127028,37.9615578 L128.030949,32.4293752 L158.711593,14.2586859 L197.534483,35.4427195 L222.013505,29.3202118 L243.572936,32.4293752 L285,2 L285,54 C285,59.5228475 280.522847,64 275,64 L10,64 C4.4771525,64 6.76353751e-16,59.5228475 0,54 L0,44.734142 L0,44.734142 Z",
    id: "\\u8DEF\\u5F84-3",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84",
    stroke: "#8C51FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0 44.734142 0 44.734142 34.7359662 48.1554298 73.5294663 32.4293752 103.127028 37.9615578 128.030949 32.4293752 158.711593 14.2586859 197.534483 35.4427195 222.013505 29.3202118 243.572936 32.4293752 285 2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph2);
export default __webpack_public_path__ + "static/media/graph2.cd453d3318a0f5bc4a97c3f9205ab379.svg";
export { ForwardRef as ReactComponent };